import {
  type ContextType,
  type Dispatch,
  type FC,
  type PropsWithChildren,
  type SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

type HierarchyLabelDrawerState =
  | { open: false }
  | { open: true; isEditing: false }
  | { open: true; isEditing: true; id: string };

const Context = createContext<
  | {
      drawerState: HierarchyLabelDrawerState;
      setDrawerState: Dispatch<SetStateAction<HierarchyLabelDrawerState>>;
    }
  | undefined
>(undefined);

const _useContext = (): NonNullable<ContextType<typeof Context>> => {
  const context = useContext(Context);
  if (!context) {
    throw new Error(
      'useDrawerState must be used within HierarchyLabelsDrawerStateProvider.',
    );
  }
  return context;
};

export const useHierarchyLabelsDrawerState = () => {
  return _useContext();
};

export const HierarchyLabelsDrawerStateProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [drawerState, setDrawerState] = useState<HierarchyLabelDrawerState>({
    open: false,
  });

  return (
    <Context.Provider value={{ drawerState, setDrawerState }}>
      {children}
    </Context.Provider>
  );
};
